export default __webpack_public_path__ + "static/media/Niraj Srivastava (2)_page-0001.c8000949.jpg";